import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.is-array";
export default function isSelected(itemValue, selectedValue) {
  if (!selectedValue) {
    return false;
  }

  return Array.isArray(selectedValue) ? selectedValue.findIndex(function (item) {
    return item.value === itemValue.value;
  }) >= 0 : selectedValue.value === itemValue.value;
}